import { noop } from './util';
import { isPromise } from './validate';
export function callInterceptor(interceptor, { args = [], done, canceled, }) {
    if (interceptor) {
        // eslint-disable-next-line prefer-spread
        const returnVal = interceptor.apply(null, args);
        if (isPromise(returnVal)) {
            returnVal
                .then((value) => {
                if (value) {
                    done();
                }
                else if (canceled) {
                    canceled();
                }
            })
                .catch(noop);
        }
        else if (returnVal) {
            done();
        }
        else if (canceled) {
            canceled();
        }
    }
    else {
        done();
    }
}
